module.exports = __webpack_public_path__ + "img/small-5.339feb12.jpg";